import {
  Box,
  Checkbox,
  Divider,
  FormControlLabel,
  FormGroup,
  Grid2,
  IconButton,
  Paper,
  TextField,
  Typography,
  Collapse,
  Switch,
  Autocomplete,
} from "@mui/material";
import React, { Fragment, useState, useEffect } from "react";
import { commonCss } from "../../StyleConfig/CommonCss";
import { Clear, Save } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { api } from "../API/config";
import { axiosPrivate } from "../../axios/axios";

const CertificateSelect = ({
  handleCloseClick,
  data,
  deleteBol,
  riskData,
  staffList,
}) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const [certificate, setCertificate] = useState([]);
  const [certificateCount, setCertificateCount] = useState({});
  const [isolationAdoptMode, setIsolationAdoptMode] = useState(false);
  const [selectedSourceForm, setSelectedSourceForm] = useState(null);
  const [selectedIsolationPoints, setSelectedIsolationPoints] = useState([]);
  const [deisolationPermits, setDeisolationPermits] = useState([]);
  const [loadingPermits, setLoadingPermits] = useState(false);
  const [adoptableCertificates, setAdoptableCertificates] = useState([]);
  const [loadingAdoptable, setLoadingAdoptable] = useState(false);
  const [selectedCertificate, setSelectedCertificate] = useState({
    ...data,
    companyId: data.companyId,
    workDescription: data.workDescription,
    enableHotWorkCertificate:
      data.enableHotWorkCertificate && deleteBol.enableHotWorkCertificate,
    enableConfinedSpaceCertificate:
      data.enableConfinedSpaceCertificate &&
      deleteBol.enableConfinedSpaceCertificate,
    enableSystemOverridingCertificate:
      data.enableSystemOverridingCertificate &&
      deleteBol.enableSystemOverridingCertificate,
    enableExcavationCertificate:
      data.enableExcavationCertificate && deleteBol.enableExcavationCertificate,
    enableIsolationCertificate:
      data.enableIsolationCertificate && deleteBol.enableIsolationCertificate,
    enableLiftingAndHoistingCertificate:
      data.enableLiftingAndHoistingCertificate &&
      deleteBol.enableLiftingAndHoistingCertificate,
    enableRadiationCertificate:
      data.enableRadiationCertificate && deleteBol.enableRadiationCertificate,
    hotWorkCertificateCount: 0,
    confinedSpaceCertificateCount: 0,
    liftingAndHoistingCertificateCount: 0,
    radiationCertificateCount: 0,
    isolationCertificateCount: 0,
    excavationCertificateCount: 0,
    systemOverridingCertificateCount: 0,
    operationalMeasures: data.enableIsolationCertificate
      ? { ...data.operationalMeasures }
      : null,
    formDetail: {
      ...data.formDetail,
      jmsDocuments: data?.formDetail?.isJMSRequired
        ? riskData.jmsDocuments.map((obj) => obj.id).toString()
        : data?.formDetail?.jmsDocuments,
      jsaDocuments: data?.formDetail?.isJSARequired
        ? riskData.jsaDocuments.map((obj) => obj.id).toString()
        : data?.formDetail?.jsaDocuments,
      classifiedAreaWhere:
        data.formDetail.classifiedAreaWhere.length !== 0
          ? data.formDetail.classifiedAreaWhere.toString()
          : null,
      classifiedAreaWithWhat:
        data.formDetail.classifiedAreaWithWhat.length !== 0
          ? data.formDetail.classifiedAreaWithWhat.toString()
          : null,
      operationalInformationWhat:
        data.formDetail.operationalInformationWhat.length !== 0
          ? data.formDetail.operationalInformationWhat.toString()
          : null,
      additionalPPPEWhere:
        data.formDetail.additionalPPPEWhere.length !== 0
          ? data.formDetail.additionalPPPEWhere.toString()
          : null,
      staffListText: staffList.length !== 0 ? staffList.toString() : null,
    },
  });

  const dispatch = useDispatch();

  console.log("staff", staffList);

  useEffect(() => {
    fetchDeisolationPermits();
  }, []);

  const fetchDeisolationPermits = async () => {
    try {
      setLoadingPermits(true);
      const response = await axiosPrivate.get(
        api.isolation.getDeisolationPermits,
      );
      setDeisolationPermits(response.data || []);
    } catch (error) {
      console.error("Error fetching deisolation permits:", error);
      toast.error("Failed to load form list");
    } finally {
      setLoadingPermits(false);
    }
  };

  const certificateNameList = [
    {
      name: "enableHotWorkCertificate",
      label: "Hot Work",
      countName: "hotWorkCertificateCount",
    },
    {
      name: "enableConfinedSpaceCertificate",
      label: "Confined Space",
      countName: "confinedSpaceCertificateCount",
    },
    {
      name: "enableSystemOverridingCertificate",
      label: "System Overriding",
      countName: "systemOverridingCertificateCount",
    },
    {
      name: "enableExcavationCertificate",
      label: "Excavation",
      countName: "excavationCertificateCount",
    },
    {
      name: "enableIsolationCertificate",
      label: "Isolation",
      countName: "isolationCertificateCount",
    },
    {
      name: "enableLiftingAndHoistingCertificate",
      label: "Lifting & Hoisting",
      countName: "liftingAndHoistingCertificateCount",
    },
    {
      name: "enableRadiationCertificate",
      label: "Radiation",
      countName: "radiationCertificateCount",
    },
  ];

  const handleSave = async () => {
    if (
      selectedCertificate.enableHotWorkCertificate ||
      selectedCertificate.enableConfinedSpaceCertificate ||
      selectedCertificate.enableSystemOverridingCertificate ||
      selectedCertificate.enableExcavationCertificate ||
      selectedCertificate.enableIsolationCertificate ||
      selectedCertificate.enableLiftingAndHoistingCertificate ||
      selectedCertificate.enableRadiationCertificate
    ) {
      if (
        isolationAdoptMode &&
        selectedCertificate.enableIsolationCertificate
      ) {
        if (!selectedSourceForm) {
          toast.error("Please Select Source Form to Adopt Isolation");
          return;
        }
        if (selectedIsolationPoints.length === 0) {
          toast.error(
            "Please Select at Least One Isolation Certificate to Adopt",
          );
          return;
        }
      }

      const saveLink = api.PTWForm.saveForm;
      const postData = {
        ...selectedCertificate,
        isolationCertificateCount:
          isolationAdoptMode &&
          selectedCertificate.enableIsolationCertificate &&
          selectedIsolationPoints.length > 0
            ? 0
            : Number(selectedCertificate.isolationCertificateCount),
      };

      const doSave = () => {
        console.log(postData);
        axiosPrivate
          .post(`${saveLink}`, postData)
          .then((res) => {
            console.log(res);
            if (
              isolationAdoptMode &&
              selectedCertificate.enableIsolationCertificate &&
              selectedIsolationPoints.length > 0
            ) {
              const adoptPayload = {
                targetFormId: data.id,
                adoptedCertificateIds: selectedIsolationPoints.map(
                  (p) => p.id,
                ),
                newCertificateCount:
                  Number(selectedCertificate.isolationCertificateCount) -
                  selectedIsolationPoints.length,
              };
              axiosPrivate
                .post(api.isolation.adoptAndCreate, adoptPayload)
                .then(() => {
                  toast.success("Successfully Added");
                  handleCloseClick();
                })
                .catch((e) => {
                  toast.error(e.response.data.message);
                  console.log(e, "adopt and create");
                });
            } else {
              toast.success("Successfully Added");
              handleCloseClick();
            }
          })
          .catch((e) => {
            toast.error(e.response.data.message);
            console.log(e, "add certificate");
          });
      };

      if (data.isLeadPermitIssuerApproved) {
        const ValidateCertificateApproved =
          api.PTWForm.ValidateCertificateApproved;
        axiosPrivate
          .get(
            `${ValidateCertificateApproved}?id=${data.id}&&roleName=${atob(searchParams.get("requestor"))}`,
          )
          .then((res) => {
            console.log(res);
            doSave();
          })
          .catch((e) => {
            console.log(e);
            toast.error(e.response.data.message);
          });
      } else {
        doSave();
      }
    } else {
      toast.error("Please Select Certificate");
    }
  };
  const handleCheckBox = (e, detail) => {
    // if(e.target.checked){
    //     setCertificate([...certificate,detail])
    //     setCertificateCount({...certificateCount,[detail.name]:1})
    //   }else{
    //     setCertificate(certificate.filter(fil=>fil.label!==detail.label))
    //     setCertificateCount({...certificateCount,[detail.name]:0})
    //   }
    console.log({
      ...selectedCertificate,
      [e.target.name]: e.target.checked,
      [detail.countName]:
        detail.countName !== "isolationCertificateCount"
          ? 1
          : e.target.checked
            ? selectedCertificate.isolationCertificateCount
            : 0,
    });

    setSelectedCertificate({
      ...selectedCertificate,
      [e.target.name]: e.target.checked,
      [detail.countName]:
        detail.countName !== "isolationCertificateCount"
          ? 1
          : e.target.checked
            ? Number(selectedCertificate.isolationCertificateCount) === 0
              ? 1
              : selectedCertificate.isolationCertificateCount
            : 0,
    });
  };

  // Fetch reconnection permits for form selection
  const fetchAdoptableCertificates = async (formId) => {
    try {
      setLoadingAdoptable(true);
      const response = await axiosPrivate.get(
        `${api.isolation.getAdoptableCertificates}/${formId}`,
      );
      setAdoptableCertificates(response.data || []);
    } catch (error) {
      console.error("Error fetching adoptable certificates:", error);
      toast.error("Failed to load isolation points");
    } finally {
      setLoadingAdoptable(false);
    }
  };

  return (
    <Paper sx={{ background: "white", p: 1.5 }}>
      <Grid2 container>
        <Grid2 size={12}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Typography
              fontWeight={600}
              color="rgb(0, 86, 151)"
              sx={{ fontSize: "1.3rem" }}
            >
              Certificate
            </Typography>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                width: "40%",
                justifyContent: "flex-end",
                gap: "1rem",
              }}
            >
              <IconButton onClick={handleSave}>
                <Save sx={{ color: commonCss.blue }} />
              </IconButton>
              <IconButton onClick={handleCloseClick}>
                <Clear sx={{ color: commonCss.blue }} />
              </IconButton>
            </Box>
          </Box>
          <Divider
            sx={{
              borderColor: commonCss.darkBlue,
              borderWidth: 1,
              width: "100%",
            }}
          />
        </Grid2>
        <Grid2 size={12}>
          <FormGroup>
            {certificateNameList.map((typeLevel, i) => (
              <Fragment key={i}>
                {typeLevel.label === "Isolation" ? (
                  <>
                    {/* Isolation Checkbox */}
                    <FormControlLabel
                      sx={{ mt: 1.5 }}
                      control={
                        <Checkbox
                          disabled={deleteBol[typeLevel.name]}
                          checked={selectedCertificate[`${typeLevel.name}`]}
                          name={typeLevel.name}
                          sx={{
                            "& .MuiSvgIcon-root": {
                              color: "rgb(0, 86, 151)",
                            },
                            "&:checked": {
                              color: "rgb(0, 86, 151)",
                            },
                          }}
                          onChange={(e) => {
                            handleCheckBox(e, typeLevel);
                            if (!e.target.checked) {
                              setIsolationAdoptMode(false);
                              setSelectedSourceForm(null);
                              setSelectedIsolationPoints([]);
                            }
                          }}
                        />
                      }
                      label={typeLevel.label}
                    />

                    {/* Isolation Options - Level 2 */}
                    <Collapse
                      in={selectedCertificate.enableIsolationCertificate}
                    >
                      <Box
                        sx={{
                          ml: 4,
                          mt: 1,
                          p: 2,
                          bgcolor: "#f9f9f9",
                          borderRadius: 1,
                        }}
                      >
                        {/* Direct Count Input - Show by default */}
                        <TextField
                          fullWidth
                          type="number"
                          variant="outlined"
                          size="small"
                          label="Isolation Certificate Count"
                          slotProps={{
                            input: {
                              inputProps: {
                                max: 3,
                                min: 1,
                              },
                            },
                          }}
                          value={selectedCertificate.isolationCertificateCount}
                          onChange={(e) => {
                            const num = Number(e.target.value);
                            if (
                              (num >= 1 && num <= 3) ||
                              e.target.value === ""
                            ) {
                              setSelectedCertificate({
                                ...selectedCertificate,
                                isolationCertificateCount: e.target.value,
                              });
                              setSelectedSourceForm(null);
                              setSelectedIsolationPoints([]);
                              setAdoptableCertificates([]);
                            } else {
                              toast.error(
                                "Isolation Certificate Count should be between 1 to 3",
                              );
                            }
                          }}
                          sx={{
                            mb: 2,
                            "& .MuiOutlinedInput-root": {
                              backgroundColor: commonCss.inputBackgroundColor,
                              borderRadius: commonCss.inputBorderRadius,
                            },
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderColor: commonCss.inputBorderColor,
                            },
                          }}
                        />

                        {/* Toggle for adoption option */}
                        <FormControlLabel
                          control={
                            <Switch
                              size="small"
                              checked={isolationAdoptMode}
                              onChange={(e) =>
                                setIsolationAdoptMode(e.target.checked)
                              }
                            />
                          }
                          label={
                            <Typography variant="body2">
                              Adopt isolation from another form?
                            </Typography>
                          }
                        />

                        {/* Form Selection - Level 3 */}
                        <Collapse in={isolationAdoptMode}>
                          <Box sx={{ mt: 2 }}>
                            <Autocomplete
                              options={deisolationPermits}
                              getOptionLabel={(option) => option.seqNo || ""}
                              value={selectedSourceForm}
                              onChange={(event, newValue) => {
                                setSelectedSourceForm(newValue);
                                setSelectedIsolationPoints([]);
                                setAdoptableCertificates([]);
                                if (newValue?.id) {
                                  fetchAdoptableCertificates(newValue.id);
                                }
                              }}
                              loading={loadingPermits}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Select Source Form"
                                  variant="outlined"
                                  size="small"
                                />
                              )}
                              sx={{ mb: 2 }}
                            />

                            {/* Isolation Points Selection - Level 4 */}
                            {selectedSourceForm && (
                              <Autocomplete
                                multiple
                                options={adoptableCertificates}
                                loading={loadingAdoptable}
                                getOptionLabel={(option) => option.refNo || ""}
                                value={selectedIsolationPoints}
                                onChange={(event, newValue) => {
                                  const maxCount =
                                    Number(
                                      selectedCertificate.isolationCertificateCount,
                                    ) || 1;
                                  if (newValue.length <= maxCount) {
                                    setSelectedIsolationPoints(newValue);
                                  } else {
                                    toast.error(
                                      `You can select at most ${maxCount} certificate(s) based on the isolation count`,
                                    );
                                  }
                                }}
                                getOptionDisabled={(option) =>
                                  selectedIsolationPoints.length >=
                                    (Number(
                                      selectedCertificate.isolationCertificateCount,
                                    ) || 1) &&
                                  !selectedIsolationPoints.find(
                                    (s) => s === option,
                                  )
                                }
                                filterSelectedOptions
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label="Select Isolation Points to Copy"
                                    placeholder="Points"
                                    size="small"
                                    helperText={`Select up to ${Number(selectedCertificate.isolationCertificateCount) || 1} certificate(s)`}
                                  />
                                )}
                              />
                            )}
                          </Box>
                        </Collapse>
                      </Box>
                    </Collapse>
                  </>
                ) : (
                  <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                    <FormControlLabel
                      sx={{ mt: 1.5 }}
                      control={
                        <Checkbox
                          disabled={deleteBol[typeLevel.name]}
                          checked={selectedCertificate[`${typeLevel.name}`]}
                          name={typeLevel.name}
                          sx={{
                            "& .MuiSvgIcon-root": {
                              color: "rgb(0, 86, 151)",
                            },
                            "&:checked": {
                              color: "rgb(0, 86, 151)",
                            },
                          }}
                          onChange={(e) => {
                            handleCheckBox(e, typeLevel);
                          }}
                        />
                      }
                      label={typeLevel.label}
                    />
                  </Box>
                )}
              </Fragment>
            ))}
          </FormGroup>
        </Grid2>
      </Grid2>
    </Paper>
  );
};

export default CertificateSelect;
